// HomePartnersWall.js — P10 section 2. Renders the partner logos the CMS
// already has (HomePartner model / /api/blog/partners/) which the homepage
// previously never surfaced — only a "Trusted by 50+ Partners" text line
// linked here. Renders nothing when there are no partner records.
import React, { useEffect, useState } from 'react';
import { getPartners } from '../services/api';
import './HomePartnersWall.css';

export default function HomePartnersWall() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    getPartners()
      .then((data) => setPartners(Array.isArray(data) ? data : (data.results || [])))
      .catch(() => {});
  }, []);

  const logos = partners.filter((p) => p.logo_url);
  if (logos.length === 0) return null;

  return (
    <section className="partners-wall-section" aria-labelledby="partners-wall-heading">
      <div className="partners-wall-container">
        <p id="partners-wall-heading" className="partners-wall-heading">
          Our partner universities
        </p>
        <ul className="partners-wall-grid">
          {logos.map((p) => (
            <li key={p.id} className="partners-wall-item">
              <img
                src={p.logo_url}
                alt={p.name}
                className="partners-wall-logo"
                width={140}
                height={64}
                loading="lazy"
                decoding="async"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
